(function () {
  if (window.c3Cart) return;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var drawer = $('#c3-drawer'), veil = $('[data-c3-veil]'), menu = $('#c3-mobile');
  if (!drawer) return;
  var cfg = drawer.dataset;
  var fmt = new Intl.NumberFormat(cfg.locale || 'en', { style: 'currency', currency: cfg.currency || 'EUR' });
  var money = function (c) { return fmt.format(c / 100); };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; };

  function render(cart) {
    $$('[data-c3-count]').forEach(function (n) { n.textContent = cart.item_count; });
    var lines = $('[data-c3-lines]');
    if (!cart.items.length) {
      lines.innerHTML = '<div class="c3-empty">Bag is empty</div>';
    } else {
      lines.innerHTML = cart.items.map(function (it, i) {
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<p>' + esc(it.variant_title) + '</p>' : '';
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '';
        return '<div class="c3-line"><img src="' + esc(img) + '" alt="">' +
          '<div><h3>' + esc(it.product_title) + '</h3>' + variant +
          '<div class="c3-qty"><button type="button" data-c3-qty="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-c3-qty="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div></div>' +
          '<div class="c3-line__price">' + money(it.final_line_price) + '<button class="c3-line__rm" type="button" data-c3-qty="' + (i + 1) + '" data-q="0">Remove</button></div></div>';
      }).join('');
    }
    $('[data-c3-foot]').classList.toggle('has-items', cart.items.length > 0);
    $('[data-c3-sub]').textContent = money(cart.total_price);
    var left = 2 - cart.item_count;
    $('[data-c3-ship]').textContent = cart.item_count === 0 ? 'Free shipping from 2 items' : (left > 0 ? 'Add ' + left + ' more — free shipping' : 'Free shipping unlocked');
    $('[data-c3-bar]').style.width = Math.min(100, cart.item_count / 2 * 100) + '%';
  }
  function refresh() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; }); }
  function open() { drawer.classList.add('is-open'); veil.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); refresh(); }
  function close() { drawer.classList.remove('is-open'); veil.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }
  function change(line, q) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: q }) })
      .then(function (r) { return r.json(); }).then(render);
  }
  function add(id, qty) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; }); })
      .then(function () { open(); });
  }
  window.c3Cart = { open: open, close: close, add: add, refresh: refresh };

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-c3-open-cart],[data-c3-close-cart],[data-c3-veil],[data-c3-qty],[data-c3-open-menu],[data-c3-close-menu]');
    if (!t) return;
    if (t.hasAttribute('data-c3-open-cart')) open();
    else if (t.hasAttribute('data-c3-close-cart') || t.hasAttribute('data-c3-veil')) close();
    else if (t.hasAttribute('data-c3-qty')) change(+t.getAttribute('data-c3-qty'), +t.getAttribute('data-q'));
    else if (t.hasAttribute('data-c3-open-menu')) { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); }
    else if (t.hasAttribute('data-c3-close-menu')) { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); menu.classList.remove('is-open'); } });
  refresh();
})();